import Select from 'react-select';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
  width: 100%;
`;

export const Div = styled.div``;
